/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AverageTimeFromSfToDepositDto, DashboardAverageItem } from '@gh/builder-shared-data';

export type AverageTimeFromSfToDeposit = AverageTimeFromSfToDepositDto;
export const averageTimeFromSfToDepositFromDto = (dto: AverageTimeFromSfToDepositDto): DashboardAverageItem[] => [
  {
    label: '',
    value: dto.numberOfDays,
    isMain: true,
    format: 'Quantity',
    subtitle: 1 === dto.numberOfDays ? 'lbl_day' : 'lbl_days',
  },
];
